/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserCreateRequest {
    getFixupPrototypeFunction() { return UserCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<UserCreateRequest>): UserCreateRequest {
        let obj = Object.assign(new UserCreateRequest(), model);
        UserCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserCreateRequest>): UserCreateRequest {
        if (!model) return null;
        return UserCreateRequest.newInstance(<UserCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserCreateRequest) {
        if (!obj) return;

        models.UserCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserCreateRequest): boolean {
        Object.setPrototypeOf(obj, UserCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.role_assignment) {
            for (let val of this.role_assignment) {
                models.AddRoleAssignment.fixupPrototype(val);
            }
        }
    }

    /**
     * The unique username for the user to be created. This value is expected to be unique across all accounts. Hence it is recommended that you use the email address as the value here. Validations:- Min length - 5, Alphanumeric
     */
    username: string;

    /**
     * Email ID of the user. This wil be unique across all the CoreStack accounts
     */
    email: string;

    /**
     * ID of the timezone to be set for th user. For a valid list of timezone values to use, please refer https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
     */
    timezone_id: string;

    /**
     * ID of the Account in CoreStack. It will be available in the authToken API response
     */
    account_id: string;

    /**
     * First Name of the user. It can be only alphanumeric
     */
    first_name: string;

    /**
     * Last Name of the user. It can be only alphanumeric
     */
    last_name: string;

    /**
     * List of roles assignments for the user. The same user can be assigned different roles in different tenants
     */
    role_assignment: Array<models.AddRoleAssignment>;

    /**
     * Is Access Key to be generated for this user
     */
    is_accesskey_required: boolean = false;

}
